import * as React from 'react';
import * as theme from 'theme.js';

import './CircleContainer.pcss';

export function CircleContainer(props:{children:React.ReactNode, color?:string}) {
  const color = props.color ? props.color : theme.EgyptianLightBlue;
  return (
    <div className={"circle-container"} style={{backgroundColor:color}}>{props.children}</div>
  );
}